import React, { useEffect, useState, useCallback } from "react";
import { TiPlus, TiMinus } from "react-icons/ti";
import { FiRefreshCw } from "react-icons/fi"; // icono refrescar
import { getLogsStream } from "../../../api/EvolucionApi"; // ajusta ruta según tu proyecto
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";

const LogsRealtime = () => {
  const [logs, setLogs] = useState([]);
  const [showActivas, setShowActivas] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchlogs = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getLogsStream();
      setLogs(response);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchlogs();
  }, [fetchlogs]);

  return (
    <div className="card mt-4">
      <div className="card-header collapsible-header" onClick={() => setShowActivas((prev) => !prev)}>
        <h4 className="card-title mb-0">Operaciones de Enfermería</h4>
        <div className="d-flex align-items-center gap-3">
          {/* Botón refrescar */}
          <FiRefreshCw
            role="button"
            onClick={(event) => { event.stopPropagation(); fetchlogs(); }}
            style={{ cursor: "pointer", fontSize: "1.4rem" }}
            title="Refrescar"
          />
          {/* Botón mostrar/ocultar */}
          <i
            className="collapsible-toggle"
            style={{ cursor: "pointer", fontSize: "1.5rem" }}
          >
            {showActivas ? <TiMinus /> : <TiPlus />}
          </i>
        </div>
      </div>

      {showActivas && (
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Cuenta</th>
                  <th>Operación</th>
                  <th>Usuario</th>
                  <th>Fecha</th>
                  <th>Opc.</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      <div className="d-flex justify-content-center align-items-center py-3">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                          style={{ width: "2rem", height: "2rem" }}
                        >
                          <span className="visually-hidden">Cargando...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : logs.length > 0 ? (
                  logs.map((log) => (
                    <tr key={log.idlogsoperaciones}>
                      <td>{log.idlogsoperaciones}</td>
                      <td>{log.usuario}</td>
                      {/* Operación truncada */}
                      <td
                        style={{
                          maxWidth: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={log.operacion}
                      >
                        {log.operacion}
                      </td>
                      <td>{log.NombrePaciente || "Sin asignar"}</td>
                      <td>{log.fechahora}</td>
                      <td>
                        <Link to={`/legajo/${log.idlegajo}`}>
                          <FaEye style={{ fontSize: "1.2rem" }} />
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No hay registros todavía...
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default LogsRealtime;
